import { ChartConstants } from "../shared/constants.js"
import { chartJahresLabel, chartXZuReal } from "./zeitachse.js"

const STANDARD_TOOLTIP_POINT_FORMATTER = function () {
	if (this.y != 0) {
		return `<span>${this.series.name}: ${Highcharts.numberFormat(this.y, 2)}&nbsp;€</span>`
	}

	return false
}

function formatMonatJahrLang(utcMs) {
	return new Intl.DateTimeFormat("de-DE", {
		month: "long",
		year: "numeric",
		timeZone: "UTC",
	}).format(new Date(utcMs))
}

function chartTooltipTitel(chartData, chartX, groupingAktiv) {
	if (!groupingAktiv) return formatMonatJahrLang(chartXZuReal(chartX, chartData))

	return chartJahresLabel(chartData, chartX)
}

export function buildTooltipFormatter(chartKredit) {
	return function () {
		const points = this.points || []
		const groupingAktiv = !!chartKredit.chart?.options?.plotOptions?.series?.dataGrouping?.enabled
		const titel = chartTooltipTitel(chartKredit.data, this.x, groupingAktiv)
		const pointFormatter =
			chartKredit.chart?.options?.tooltip?.pointFormatter || Highcharts.getOptions()?.tooltip?.pointFormatter || STANDARD_TOOLTIP_POINT_FORMATTER
		const zeilen = points.map((point) => {
			if (point.y == null || point.y === 0 || !point.series.visible) return false
			return pointFormatter.call(point.point || point)
		})
		const header = `<span style="font-size:${ChartConstants.fontSizeKlein}; line-height:1.2; font-weight:400; color:${ChartConstants.fontColorSchwarz};">${titel}</span>`

		return [header, ...zeilen]
	}
}
